import WorkHoursModal from './work-hours-modal';

export default WorkHoursModal;
